export default {
  initJsbridge() {
    window.connectWebViewJavascriptBridge = function (callback) {
      if (window.WebViewJavascriptBridge) {
        callback(window.WebViewJavascriptBridge);
      } else {
        document.addEventListener(
          "WebViewJavascriptBridgeReady",
          function () {
            callback(window.WebViewJavascriptBridge);
          },
          false
        );
        if (!/Android/.test(navigator.userAgent)) {
          if (window.WebViewJavascriptBridge) {
            return callback(window.WebViewJavascriptBridge);
          }
          if (window.WVJBCallbacks) {
            return window.WVJBCallbacks.push(callback);
          }
          window.WVJBCallbacks = [callback];
          var WVJBIframe = document.createElement("iframe");
          WVJBIframe.style.display = "none";
          WVJBIframe.src = "wvjbscheme://__BRIDGE_LOADED__";
          document.documentElement.appendChild(WVJBIframe);
          setTimeout(function () {
            document.documentElement.removeChild(WVJBIframe);
          }, 0);
        }
      }
    };
    window.connectWebViewJavascriptBridge(function (bridge) {
      try {
        // eslint-disable-next-line no-unused-vars
        bridge.init(function (message, responseCallback) {
          console.log("init" + message);
        });
      } catch (error) {
        console.log("init error: " + error);
      }
    });
  },
};
